import { render, staticRenderFns } from "./EditorBase.vue?vue&type=template&id=47e0152e"
import script from "./EditorBase.vue?vue&type=script&lang=js"
export * from "./EditorBase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports